/* ZOALIN_MOBILE_HOME_HEADER_CENTER_FINAL_20260720 */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var styleId = 'zoalin-mobile-home-header-center-final-runtime-20260720';

  function setImportant(element, styles) {
    if (!element) return;
    Object.keys(styles).forEach(function (property) {
      element.style.setProperty(property, styles[property], 'important');
    });
  }

  function isHomeMobile() {
    return mq.matches && document.body && document.body.classList.contains('template-index');
  }

  function drawerIsOpen() {
    return document.body.classList.contains('zoalin-menu-drawer-open') ||
      !!document.querySelector('#Details-menu-drawer-container[open], #Details-menu-drawer-container.menu-open');
  }

  function injectStyle() {
    if (!isHomeMobile() || document.getElementById(styleId)) return;
    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = [
      '/* ZOALIN_MOBILE_HOME_HEADER_CENTER_FINAL_RUNTIME_20260720 */',
      '@media(max-width:749px){',
      'html body.template-index{--zoalin-home-header-height-final:56px!important;--zoalin-home-header-side-final:24px!important;--zoalin-home-header-touch-final:44px!important;--zoalin-home-logo-width-final:90px!important;}',
      'html body.template-index .header-section,html body.template-index #header-component,html body.template-index header-component,html body.template-index #header-component>.header__row,html body.template-index header-component>.header__row{position:relative!important;left:0!important;right:auto!important;width:100%!important;max-width:100%!important;height:var(--zoalin-home-header-height-final)!important;min-height:var(--zoalin-home-header-height-final)!important;max-height:var(--zoalin-home-header-height-final)!important;margin:0!important;padding:0!important;transform:none!important;background:#fff!important;overflow:visible!important;}',
      'html body.template-index #header-component .header-logo,html body.template-index #header-component .header-logo__link,html body.template-index #header-component .header-logo__text,html body.template-index #header-component .header-logo__wordmark,html body.template-index header-component .header-logo,html body.template-index header-component .header-logo__link,html body.template-index header-component .header-logo__text,html body.template-index header-component .header-logo__wordmark{position:absolute!important;left:50%!important;top:50%!important;right:auto!important;bottom:auto!important;transform:translate(-50%,-50%)!important;display:flex!important;width:var(--zoalin-home-logo-width-final)!important;min-width:var(--zoalin-home-logo-width-final)!important;max-width:var(--zoalin-home-logo-width-final)!important;height:auto!important;min-height:0!important;margin:0!important;padding:0!important;align-items:center!important;justify-content:center!important;line-height:0!important;z-index:1211!important;}',
      'html body.template-index #Details-menu-drawer-container[open]>.menu-drawer>.zoalin-menu-drawer-head,html body.template-index #Details-menu-drawer-container.menu-open>.menu-drawer>.zoalin-menu-drawer-head,html body.template-index.zoalin-menu-drawer-open #Details-menu-drawer-container>.menu-drawer>.zoalin-menu-drawer-head{display:grid!important;grid-template-columns:minmax(0,1fr)!important;grid-template-rows:38px 38px!important;justify-items:start!important;align-items:center!important;gap:4px!important;min-height:98px!important;padding:11px 58px 10px 18px!important;box-sizing:border-box!important;}',
      'html body.template-index #Details-menu-drawer-container[open]>.menu-drawer>.zoalin-menu-drawer-head .zoalin-menu-drawer-logo,html body.template-index #Details-menu-drawer-container.menu-open>.menu-drawer>.zoalin-menu-drawer-head .zoalin-menu-drawer-logo,html body.template-index.zoalin-menu-drawer-open #Details-menu-drawer-container>.menu-drawer>.zoalin-menu-drawer-head .zoalin-menu-drawer-logo{grid-column:1!important;grid-row:1!important;justify-self:start!important;align-self:center!important;margin:0 0 0 4px!important;text-align:left!important;transform:none!important;}',
      'html body.template-index #Details-menu-drawer-container[open]>.menu-drawer>.zoalin-menu-drawer-head .zoalin-menu-drawer-actions,html body.template-index #Details-menu-drawer-container.menu-open>.menu-drawer>.zoalin-menu-drawer-head .zoalin-menu-drawer-actions,html body.template-index.zoalin-menu-drawer-open #Details-menu-drawer-container>.menu-drawer>.zoalin-menu-drawer-head .zoalin-menu-drawer-actions{grid-column:1!important;grid-row:2!important;justify-self:start!important;align-self:center!important;justify-content:flex-start!important;margin:0 0 0 4px!important;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function applyHeaderCentering() {
    if (!isHomeMobile()) return;
    injectStyle();

    var header = document.querySelector('#header-component') || document.querySelector('header-component');
    var row = document.querySelector('#header-component > .header__row') || document.querySelector('header-component > .header__row');
    var logo = document.querySelector('#header-component .header-logo') || document.querySelector('header-component .header-logo');
    var logoParts = document.querySelectorAll(
      '#header-component .header-logo, #header-component .header-logo__link, #header-component .header-logo__text, #header-component .header-logo__wordmark, ' +
      'header-component .header-logo, header-component .header-logo__link, header-component .header-logo__text, header-component .header-logo__wordmark'
    );
    var menu = document.querySelector('#header-component summary.header__icon.header__icon--menu.header__icon--summary') ||
      document.querySelector('header-component summary.header__icon.header__icon--menu.header__icon--summary');
    var cart = document.querySelector('#header-component button.header-actions__action.button-unstyled[data-testid="cart-drawer-trigger"]') ||
      document.querySelector('header-component button.header-actions__action.button-unstyled[data-testid="cart-drawer-trigger"]');
    var drawerHead = document.querySelector('#Details-menu-drawer-container > .menu-drawer > .zoalin-menu-drawer-head');
    var drawerLogo = document.querySelector('#Details-menu-drawer-container > .menu-drawer > .zoalin-menu-drawer-head .zoalin-menu-drawer-logo');
    var drawerActions = document.querySelector('#Details-menu-drawer-container > .menu-drawer > .zoalin-menu-drawer-head .zoalin-menu-drawer-actions');

    [header, row].forEach(function (element) {
      setImportant(element, {
        position: 'relative',
        left: '0',
        right: 'auto',
        width: '100%',
        'max-width': '100%',
        height: '56px',
        'min-height': '56px',
        'max-height': '56px',
        margin: '0',
        padding: '0',
        transform: 'none',
        overflow: 'visible'
      });
    });

    logoParts.forEach(function (element) {
      setImportant(element, {
        position: 'absolute',
        left: '50%',
        top: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        width: '90px',
        'min-width': '90px',
        'max-width': '90px',
        height: 'auto',
        'min-height': '0',
        margin: '0',
        padding: '0',
        'align-items': 'center',
        'justify-content': 'center',
        'line-height': '0',
        'z-index': '1211'
      });
      if (drawerIsOpen()) {
        setImportant(element, { display: 'none', visibility: 'hidden', opacity: '0', 'pointer-events': 'none' });
      } else {
        setImportant(element, { display: 'flex', visibility: 'visible', opacity: '1' });
      }
    });

    setImportant(menu, {
      position: 'absolute',
      top: '6px',
      left: '24px',
      right: 'auto',
      width: '44px',
      'min-width': '44px',
      'max-width': '44px',
      height: '44px',
      'min-height': '44px',
      'max-height': '44px',
      margin: '0',
      padding: '0',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      transform: 'none',
      'z-index': '1212'
    });

    setImportant(cart, {
      position: 'absolute',
      top: '6px',
      left: 'auto',
      right: '24px',
      width: '44px',
      'min-width': '44px',
      'max-width': '44px',
      height: '44px',
      'min-height': '44px',
      'max-height': '44px',
      margin: '0',
      padding: '0',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      transform: 'none',
      'z-index': '1212'
    });

    if (drawerIsOpen()) {
      setImportant(drawerHead, {
        display: 'grid',
        'grid-template-columns': 'minmax(0, 1fr)',
        'grid-template-rows': '38px 38px',
        'justify-items': 'start',
        'align-items': 'center',
        gap: '4px',
        'min-height': '98px',
        padding: '11px 58px 10px 18px',
        'box-sizing': 'border-box'
      });

      setImportant(drawerLogo, {
        'grid-column': '1',
        'grid-row': '1',
        'justify-self': 'start',
        'align-self': 'center',
        margin: '0 0 0 4px',
        'text-align': 'left',
        transform: 'none'
      });

      setImportant(drawerActions, {
        'grid-column': '1',
        'grid-row': '2',
        'justify-self': 'start',
        'align-self': 'center',
        'justify-content': 'flex-start',
        margin: '0 0 0 4px'
      });
    }

    document.body.dataset.zoalinHomeHeaderCentered = '20260720';
    if (logo) {
      var rect = logo.getBoundingClientRect();
      document.body.dataset.zoalinHomeHeaderCenterDelta = String(Math.round((rect.left + rect.width / 2) - (window.innerWidth / 2)));
    }
  }

  function schedule() {
    [0, 50, 160, 420, 900, 1800].forEach(function (delay) {
      window.setTimeout(applyHeaderCentering, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
  window.addEventListener('load', schedule, { once: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule, { passive: true });

  var observer = new MutationObserver(function () {
    window.requestAnimationFrame(applyHeaderCentering);
  });
  if (document.documentElement) {
    observer.observe(document.documentElement, { attributes: true, childList: true, subtree: true, attributeFilter: ['class', 'open'] });
  }
})();
